import React from "react";

export default function PagePublicSkeleton() {
  return (
    <main className="mx-auto max-w-[1180px] px-4 pb-16 pt-8 sm:px-6">
      <div className="animate-pulse space-y-6">
        <div className="h-8 w-72 rounded-full bg-slate-200 dark:bg-slate-800" />
        <div className="h-5 w-full max-w-2xl rounded-full bg-slate-200 dark:bg-slate-800" />

        <div className="rounded-[2rem] border border-slate-200 bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-950">
          <div className="space-y-4">
            <div className="h-5 w-3/4 rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-4 w-full rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-4 w-11/12 rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-4 w-10/12 rounded-full bg-slate-200 dark:bg-slate-800" />
            <div className="h-64 rounded-[1.5rem] bg-slate-200 dark:bg-slate-800" />
          </div>
        </div>
      </div>
    </main>
  );
}